import React from 'react';

import { PropsOf } from 'app/@types/utils/props-of';

import BookDemoButton from '../BookDemoButton';
import StartTrialButton from '../StartTrialButton';
import TitleSection from '../TitleSection';

type Props = Omit<PropsOf<typeof TitleSection>, 'buttons'>;

const TopicHeading: React.FC<Props> = (props) => {
    return (
        <TitleSection
            {...props}
            buttons={
                <>
                    <BookDemoButton />
                    <StartTrialButton />
                </>
            }
        />
    );
};
export default TopicHeading;
